import * as React from 'react';

import { fromJson } from '@bufbuild/protobuf';
import {
  DriverEvent,
  DriverEventSchema,
} from '@rematter/frontend-lib-api-client/grpc/transportation/v1/driver_events_pb';
import { Col, EventDetailContainer, JsonViewer } from '@rematter/ui-web';

import { DriverCreatedDetail } from './DriverCreatedDetail';
import { DriverDeletedDetail } from './DriverDeletedDetail';
import { DriverUpdatedDetail } from './DriverUpdatedDetail';

type DriverEventDetailProps = {
  payload: string;
};

export const DriverEventDetail = ({ payload }: DriverEventDetailProps) => {
  const [showJson, setShowJson] = React.useState(false);

  const event = React.useMemo((): DriverEvent | null => {
    try {
      return fromJson(DriverEventSchema, JSON.parse(payload));
    } catch {
      return null;
    }
  }, [payload]);

  if (!event) {
    return <JsonViewer data={payload} title="Raw Payload (Parse Error)" />;
  }

  const { event: inner } = event;

  const renderEventContent = () => {
    switch (inner.case) {
      case 'created':
        return <DriverCreatedDetail event={inner.value} />;
      case 'updated':
        return <DriverUpdatedDetail event={inner.value} />;
      case 'deleted':
        return <DriverDeletedDetail event={inner.value} />;
      case 'statusChanged':
        return <JsonViewer data={payload} title="Event Data" />;
      case undefined:
        return <JsonViewer data={payload} title="Unknown Event Type" />;
    }
  };

  const getEventTitle = (): string => {
    switch (inner.case) {
      case 'created':
        return 'Driver Created';
      case 'updated':
        return 'Driver Updated';
      case 'deleted':
        return 'Driver Deleted';
      case 'statusChanged':
        return 'Driver Status Changed';
      case undefined:
      default:
        return 'Unknown Event';
    }
  };

  return (
    <Col className="@DriverEventDetail flex-1">
      <EventDetailContainer
        title={getEventTitle()}
        showJson={showJson}
        onToggleJson={() => setShowJson(!showJson)}
        jsonContent={payload}
      >
        {renderEventContent()}
      </EventDetailContainer>
    </Col>
  );
};
